<template>
    <div class="column is-half">
        <button @click="$router.push({ path: '/' })" class="button is-link">Ga terug</button><br /><br />

        <div class="notification is-danger" v-if="errorShow">
            <button class="delete" @click="HideMessage"></button>
            <b>Er is een fout opgetreden!</b><br />
            {{errorMessage}}
        </div>

        <div class="box">
            <div class="field">
                <label class="label is-small">Naam</label>
                <div class="control">
                <input class="input is-small" type="text" name="name" v-model="name">
                </div>
            </div>

            <div class="field">
                <label class="label is-small">Email</label>
                <div class="control">
                <input class="input is-small" type="text" name="email" v-model="email">
                </div>
            </div>

            <div class="field">
                <label class="label is-small">Telefoonnummer</label>
                <div class="control">
                <input class="input is-small" type="text" name="telefoon" v-model="telefoon">
                </div>
            </div>

            <div class="field is-grouped">
                <div class="control">
                <button @click="Add()" class="button is-link">Voeg toe</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormulierVoegtoe',
    data () {
        return {
            email: "",
            telefoon: "",
            name: "",
            errorMessage: "",
            errorShow: false,
        }
    },

    methods: {
        HideMessage() {
            this.errorShow = false
            this.errorMessage = ""
        },
        Add() {
            var uitvaartleider = {
                telefoon: this.telefoon,
                name: this.name,
                email: this.email,
                bedrijf_id: this.config.id
            }

            if (this.email == "") {
                this.errorMessage = "Vul een email in!"
                this.errorShow = true
            } else {
                this.axios.post('https://backend.weerstandgrafmonumenten.nl/api/contacts/new', {uitvaartleider}).then(response => {
                    if (response.data) {
                        this.errorMessage = response.data
                        this.errorShow = true
                    } else {
                        this.$router.push({ path: '/' })
                    }
                }).catch(err => {
                    this.errorMessage = err.response
                    this.errorShow = true
                })
            }
        }
    }, 

    mounted() {
  	
    },
}
</script>


// WEBPACK FOOTER //
// src/components/FormulierVoeToe.vue